const advantages = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '金融级安全认证，端到端加密传输，本地优先处理架构，全方位守护您的数据安全与隐私。',
  },
  {
    icon: 'ri-cpu-line',
    title: '技术领先',
    description: '自研核心芯片与 AI 算法，持续高研发投入，多项行业首创技术，保持技术领先优势。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '用户至上',
    description: '以用户需求为导向，30 天无理由退换，7x24 小时客服支持，48 小时上门服务承诺。',
  },
  {
    icon: 'ri-global-line',
    title: '生态开放',
    description: '200+ 品牌设备兼容，开放 API 接口，共建开放共赢的数字化生态体系。',
  },
];

export default function AdvantageSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="text-xs font-semibold tracking-widest uppercase text-primary-600">
              核心优势
            </span>
            <h2 className="mt-3 text-2xl md:text-4xl font-bold text-foreground-950">
              为什么选择 <strong>MJHL</strong>
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              四大核心优势，构筑 MJHL 不可替代的品牌竞争力
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {advantages.map((item, i) => (
              <div key={i} className="group bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7 hover:border-primary-300 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="mt-5 text-base md:text-lg font-semibold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}